export default __webpack_public_path__ + "static/media/Mobile-Logo.78b1c5dc.svg";